var domain_backend = window.location.origin + "/api";
// if (window.location.hostname === "localhost" && window.location.port === "3000") {
//     domain_backend = "http://develop.hoctot.ai:708/";
// }

const roleAvatar = [
    {role: 1, avatar: "/img/university-avatar.png"},
    {role: 2, avatar: "/img/teacher-avatar.png"},
    {role: 3, avatar: "/img/ministry-avatar.png"},
    {role: 100, avatar: "/img/student-avatar.png"},
]

const roleList = [
    {role: 1, title: "Nhà trường"},
    {role: 2, title: "Giảng viên"},
    {role: 3, title: "Giáo vụ"},
    {role: 100, title: "Sinh viên"},
]

const colorSet = {
    low: "rgb(204, 0, 0)",
    medium: "rgb(26, 152, 255)",
    high: "rgb(0, 177, 15)",
}

export { domain_backend, colorSet, roleAvatar, roleList }